export default 0.0485754772875;
